// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <img
          src="/logo_app.png"
          alt="TomboLive"
          style={s.logo}
        />
        <div style={s.code}>404</div>
        <h1 style={s.title}>Page introuvable</h1>
        <p style={s.desc}>
          Cette page n'existe pas ou a été déplacée.
        </p>
        <div style={s.actions}>
          <Link to="/" style={s.btnPrimary}>
            🏠 Retour à l'accueil
          </Link>
          <a href="https://tombo.live" style={s.btnSecondary}>
            🌐 tombo.live
          </a>
        </div>
      </div>
    </div>
  );
}

const s = {
  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#1a3a8f,#764ba2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 1rem",
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "2.5rem 2rem",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
  },
  logo: {
    width: "72px",
    height: "72px",
    objectFit: "contain",
    borderRadius: "12px",
    marginBottom: "1rem",
  },
  code: {
    fontSize: "5rem",
    fontWeight: 900,
    color: "#1a3a8f",
    lineHeight: 1,
    marginBottom: "0.5rem",
  },
  title: {
    fontSize: "1.3rem",
    fontWeight: 800,
    color: "#1a1a2e",
    marginBottom: "0.5rem",
  },
  desc: {
    color: "#888",
    fontSize: "0.9rem",
    lineHeight: 1.6,
    marginBottom: "1.75rem",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  btnPrimary: {
    padding: "0.85rem",
    background: "linear-gradient(135deg,#667eea,#764ba2)",
    color: "#fff",
    borderRadius: "12px",
    textDecoration: "none",
    fontWeight: 700,
    fontSize: "0.95rem",
  },
  btnSecondary: {
    padding: "0.85rem",
    border: "1.5px solid #e0e0e0",
    color: "#667eea",
    borderRadius: "12px",
    textDecoration: "none",
    fontWeight: 700,
    fontSize: "0.95rem",
  },
};
